<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    toggleBodyClass(method, bodyClass) {
      const el = document.body

      if (method === 'add') {
        el.classList.add(bodyClass)
      } else {
        el.classList.remove(bodyClass)
      }
    }
  },
  mounted() {
    this.toggleBodyClass('add', 'authentication-bg')
  },
  unmounted() {
    this.toggleBodyClass('remove', 'authentication-bg')
  }
}
</script>

